import { WizardField } from '../../../Field';
import { LandTypeDropdownOptions, PanelWashingDropdownOptions } from '~/constants/production-inputs';

export default function ProductionValidationOptions() {
  return (
    <WizardField.Row>
      <WizardField
        schemaKey="dnvInputLandType"
        fieldLabel="Land type"
        options={LandTypeDropdownOptions}
        placeholder={'Urban - lightly used'}
        optional
        fluid
      />
      <WizardField
        schemaKey="dnvInputPanelWashing"
        fieldLabel="Panel washing"
        options={PanelWashingDropdownOptions}
        placeholder={'None'}
        optional
        fluid
      />
    </WizardField.Row>
  );
}